export default "https://cdn-static.gokick.com/assets/b4422e726e3b42ca3d48f0d34192932f5b3fbcfa/images/sleep-blueberry.3ee2bf0b929baac3dd5c59083edb83bb.png";